import {PAYMENT_CONSTANTS} from '../app/talenlio-hireos/home-layout/common/constant/payment-constant';
import {AI_CONSTANTS} from '../app/talenlio-hireos/home-layout/common/constant/ai-constant';

export const environment = {
    name: 'local',
    production: false,
    baseApiUrl: 'http://localhost:8721/api',
    competitions: {
        enabled: true
    },
    analyticsApiUrl: 'http://localhost:3100',
    pdfAppBaseUrl: 'http://localhost:1002/api',
    firebase: {
        apiKey: "AIzaSyB1AI4k7x6JrsDtzYgc1wTgGiomgAYcb_I",
        authDomain: "dev-and-staging-talenlio.firebaseapp.com",
        databaseURL: "https://dev-and-staging-talenlio-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "dev-and-staging-talenlio",
        storageBucket: "dev-and-staging-talenlio.appspot.com",
        messagingSenderId: "703883115589",
        appId: "1:703883115589:web:1ef42e2c010e3d907bf72c",
        measurementId: "G-5QGBL6L1Q9",
        vapidKey: "BGocAB3R5Oon-eVwXt2yH--lQsBG0uBSQ7UJFXyFyC4_kMjG-YTM1nr8hnh9jqj9j72hBDa0-VeqxfKiuJpsYSU"
    },
    edgeFirebase: {
        databaseURL: "https://dev-and-staging-talenlio-edge.europe-west1.firebasedatabase.app/",
    },
    artificialIntelligenceFirebase: {
        databaseURL: "https://dev-and-staging-talenlio-artificial-intelligence.europe-west1.firebasedatabase.app/",
    },
    publicApiKey: '10260a23-0241-4171-b52d-6ece53cdff26',
    baseAppUrl: 'http://localhost:4200',
    hireOsBaseAppUrl: 'http://localhost:2109',
    standoutBaseAppUrl: 'http://localhost:1608',
    organizaBaseAppUrl: 'http://localhost:4200',
    showcaseBaseAppUrl: 'http://localhost:1608',
    payment: PAYMENT_CONSTANTS.STRIPE,
    stripeProperties: {
        publishableKey: PAYMENT_CONSTANTS.PUBLISHABLE_KEY,
        pricingTableId: PAYMENT_CONSTANTS.PRICING_TABLE_ID
    },
    aiProperties: {
        apiUrl: AI_CONSTANTS.API_URL,
        model: AI_CONSTANTS.MODEL,
        temperature: AI_CONSTANTS.TEMPERATURE,
        maxOutputTokens: AI_CONSTANTS.MAX_OUTPUT_TOKEN,
        apiKey: 'AIzaSyDr2kELob7PR2QF2i7jpsGYqF3BPkOwrcs'
    },
    signUpBatchId: 'createYourBatchReplaceIdHere',
    defaultOrganizationId: 'nzreGyM2',
    retoolConfig: {
        dashboard: {
            driveReportsUrl: 'https://ilmtec.retool.com/p/placement-drive-report?_environment=staging&placementDriveId=',
            organizaStatisticsReportUrl: 'https://ilmtec.retool.com/p/organiza-statistics?_environment=staging&universityId=',
            organizationStatisticsReportUrl: 'https://ilmtec.retool.com/p/organiza-statistics?_env=staging&organizationId=',
        }
    },
    GOOGLE_MAPS_CONFIG: {
        apiKey: 'AIzaSyA4XRbQBcxlh9aYk0IHksrVV6QQJ1sS4QY',
        mapsUrl: 'https://maps.googleapis.com/maps/api/js?libraries=places&loading=async&key='
    },
    chatApiUrl: 'http://localhost:3200/api/chat',
    chatSocketUrl: 'ws://localhost:3200',
    linkedInAuthConfig: {
        authUri: `https://www.linkedin.com/oauth/v2/authorization`,
        redirectUri: 'http://localhost:2109/auth/callback',
        clientId: '77gt2gki02vax0',
        clientSecret: 'St50veE91TJdnd76',
        responseType: 'code',
        scope: 'r_basicprofile openid profile email'
    },
    posthog: {
        apiKey: 'phc_R9xX8Z852whYFuPCXxOowJDyA7QgTBwQe47FqHujSoZ',
        apiHost: 'https://eu.i.posthog.com',
        enabled: false
    }
};
